import { format } from 'date-fns';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumericValue } from 'utils/general';

import { useHomePageContext } from '@/modules/home/context';
import { IHome } from '@/modules/home/types';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';
import routes from '@/shared/constant/routes';
import { clsxm } from '@/shared/lib';

import InfoCircle from '~/images/shared/ExleminationMark.svg';
import GreenSprayer from '~/images/shared/GreenSprayer.svg';
import GreenTractor from '~/images/shared/GreenTractor.svg';

// TODO: remove type
const WidgetTooltip: React.FC<IHome.IWidgetDetailsProps> = ({
  operation,
  // type,
}) => {
  const { push } = useRouter();
  const { t } = useTranslation('common');
  const {
    state: { date },
  } = useHomePageContext();

  const handlePeriodicClick = () => {
    if (operation.periodic > 0) {
      push({
        pathname: routes.periodicJobs,
        query: {
          date: format(date, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
          // TODO: add crop
        },
      });
    }
  };
  const handleTechnicalClick = () => {
    if (operation.technical > 0) {
      push({
        pathname: routes.workingDay,
        query: {
          date: format(date, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
          // TODO: add crop
        },
      });
    }
  };

  return (
    <TippyTooltip
      content={
        <div className='relative flex w-fit min-w-[180px] gap-16'>
          <div
            className={clsxm(
              'flex w-fit items-center gap-2',
              operation.technical > 0 && 'cursor-pointer'
            )}
            onClick={handleTechnicalClick}
          >
            <GreenTractor />
            <div className='flex flex-col text-surface-10'>
              <div className='text-12 font-medium capitalize'>
                {t('technical')}
              </div>
              <div className='text-18 font-semi-bold'>
                {formatNumericValue(operation.technical)}
              </div>
            </div>
          </div>
          <div
            className={clsxm(
              'flex w-fit items-center gap-2',
              operation.periodic > 0 && 'cursor-pointer'
            )}
            onClick={handlePeriodicClick}
          >
            <GreenSprayer />
            <div className='flex flex-col text-surface-10'>
              <div className='text-12 font-medium capitalize'>
                {t('periodic')}
              </div>
              <div className='text-18 font-semi-bold'>
                {formatNumericValue(operation.periodic)}
              </div>
            </div>
          </div>
        </div>
      }
    >
      <span className='cursor-pointer text-surface-10'>
        <InfoCircle width='16' height='16' />
      </span>
    </TippyTooltip>
  );
};
export { WidgetTooltip };
